<template>
    <div>
        <div class="d-flex align-items-center justify-content-between">
            <pills :filtro="filtroBackup" />
            <div>
                <b-button @click="$bvModal.show('bv-modal-filtro')">
                    <i class="fa-solid fa-filter mr-2"></i>
                    Filtro
                </b-button>
                <b-modal size="xl" id="bv-modal-filtro" hide-footer>
                    <filtro ref="filtro" @buscar="buscar" :filtro="filtro"/>
                </b-modal>
            </div>

        </div>

        <b-alert :show="dados.length == 0 && !buscando" variant="warning" class="mt-3">
            Não foi encontrado dados. Por favor, refaça sua busca.
        </b-alert>
        <accordion
            :title="pessoa.nome"
            class="w-100 accordion-com-avatar mt-4"
            v-for="pessoa in dados"
            :key="pessoa.id"
            :id="pessoa.id"

            @abriu="abriu(pessoa)"
        >
            <template #prepend-title>
                <b-avatar class="avatar-accordion" :src="pessoa.foto"></b-avatar>
            </template>
            <vue-perfect-scrollbar>
                <b-table-simple bordered>
                    <b-thead head-variant="dark">
                        <b-tr>
                            <b-th rowspan="2">Cód. Projeto</b-th>
                            <b-th rowspan="2">Projeto</b-th>
                            <b-th rowspan="2">#</b-th>
                            <b-th :colspan="ano.meses.length" v-for="ano,i in gerarDatas(pessoa.dados)" :key="`ano_${i}`" class="text-center">{{ano.ano}}</b-th>
                        </b-tr>
                        <b-tr>
                            <template v-for="ano,j in gerarDatas(pessoa.dados)">
                                <template v-for="mes,i in ano.meses">
                                    <b-th class="text-center" :key="`thead_mes${i}${j}`">{{mes.nomeMes}}</b-th>
                                </template>
                            </template>
                        </b-tr>
                    </b-thead>
            
                    <b-tbody >
                        <template v-for="projeto,i in pessoa.dados.response">                                
                            <b-tr :key="`linha${i}_1`">
                                <b-td rowspan="2">{{projeto.codigoProjeto}}</b-td>
                                <b-td rowspan="2">{{projeto.projeto}}</b-td>
                                <b-td>Planejado</b-td>
                                <b-td class="text-center" :class="horas.horasPrevistas > 176 ? 'text-red-500 h6' : ''" v-for="horas,i in projeto.alocacoes" :key="`horas_1_${i}`">
                                    {{horas.horasPrevistas}}
                                </b-td>
                            </b-tr>
                            <b-tr :key="`linha${i}_2`">
                                <b-td>Realizado</b-td>
                                <b-td class="text-center" :class="horas.horasRealizadas > 176 ? 'text-red-500 h6' : ''" v-for="horas,i in projeto.alocacoes" :key="`horas_2_${i}`">
                                    {{horas.horasRealizadas}}
                                </b-td>
                            </b-tr>

                        </template>
                    </b-tbody>
                    <b-tfoot>
                        <b-tr variant="warning">
                            <b-td colspan="3">Total planejado</b-td>
                            <b-td class="text-center" :class="horas > 176 ? 'bg-red-200 h6' : ''"  v-for="horas,i in pessoa.total.planejado" :key="`total_planejado_${pessoa.id}_${i}`">
                                    {{horas}}
                                </b-td>
                        </b-tr>
                        <b-tr variant="warning">
                            <b-td colspan="3">Total realizado</b-td>
                            <b-td class="text-center" :class="horas > 176 ? 'bg-red-200 h6' : ''" v-for="horas,i in pessoa.total.realizado" :key="`total_realizado_${pessoa.id}_${i}`">
                                    {{horas}}
                                </b-td>
                        </b-tr>
                    </b-tfoot>
                </b-table-simple>
            </vue-perfect-scrollbar>
        </accordion>
    </div>
</template>
<script>
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";

import PessoaService from "@/common/services/pessoa/pessoa.service";
import helpers from "@/common/utils/helpers";
import Accordion from "@/components/card/Accordion.vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Filtro from "./Filtro.vue";
import Pills from "./Pills.vue";
export default {
    name: "EquipesLista",
    components: {
        Accordion,
        VuePerfectScrollbar,
        Filtro,
        Pills
    },
    data : () => ({
        options : {
            meses : []
        },
        anos : [],

        filtro : {
            anoInicio : "",
            mesInicio : "",
            anoFinal : "",
            mesFinal : "",
        },
        filtroBackup : {},

        dados : [],
        buscando : false,
    }),
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [{ titulo: 'Equipe' }]);
        this.options.meses = helpers.retornarMeses();
        let ano = new Date().getFullYear();
        this.filtro.anoInicio = ano;
        this.filtro.anoFinal = ano+1;
        this.filtro.mesInicio = 1;
        this.filtro.mesFinal = 1;
        
    },
    methods : {
        abriu : function(pessoa){
            pessoa.dados = [];
            pessoa.total = {
                planejado : [],
                realizado : []
            }
            this.$store.dispatch(START_LOADING);
            PessoaService.buscarHorasPessoa(this.empresaSelecionada, this.filtroBackup.DataInicio, this.filtroBackup.DataFim, pessoa.id, this.filtroBackup.ProjetoGestaoId, this.filtroBackup.ProjetoPDId ).then(res => {
                pessoa.dados = res.data.data;
                this.calcularTotal(pessoa)
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        calcularTotal : function(pessoa){
            let anoInicial = helpers.formatarData(pessoa.dados.dataInicio,'YYYY');
            let mesInicial = helpers.formatarData(pessoa.dados.dataInicio,'MM');
            let anoFinal = helpers.formatarData(pessoa.dados.dataFim,'YYYY');
            let mesFinal = helpers.formatarData(pessoa.dados.dataFim,'MM');

            let indice = 0;
            let meses = {
                planejado : [],
                realizado : []
            };
            for(let i = anoInicial; i <= anoFinal; i++){
                let mes = 1;
                if(i == anoInicial){
                    mes = mesInicial;
                }
                for(let j = mes; j <= (i == anoFinal ? mesFinal : 12); j++){
                    meses.planejado.push(
                        pessoa.dados.response.reduce((total, info) => {
                            return total + (info.alocacoes[indice] ? info.alocacoes[indice].horasPrevistas : 0);
                        }, 0)
                    );
                    meses.realizado.push(
                        pessoa.dados.response.reduce((total, info) => {
                            return total + (info.alocacoes[indice] ? info.alocacoes[indice].horasRealizadas : 0);
                        }, 0)
                    );
                    indice++;
                }
            }
            
            pessoa.total = meses;
        },
        buscar: function(filtro){
            
            this.dados = [];
            this.$store.dispatch(START_LOADING);
            
            this.filtroBackup = filtro;
            this.filtro = filtro;
            
            this.buscando = true;
            PessoaService.buscarListaEquipe(this.empresaSelecionada, filtro.DataInicio, filtro.DataFim, filtro.pessoa, filtro.ProjetoGestaoId, filtro.ProjetoPDId ).then(res => {
                this.dados = res.data.data.map(el => {
                    el.dados = [];
                    el.total = {
                        planejado : [],
                        realizado : []
                    };
                    return el;
                });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
                this.buscando = false;
                //this.calcularTotal();
            });
        },
        gerarDatas : function(dados){
            let anoInicial = helpers.formatarData(dados.dataInicio,'YYYY');
            let mesInicial = helpers.formatarData(dados.dataInicio,'MM');
            let anoFinal = helpers.formatarData(dados.dataFim,'YYYY');
            let mesFinal = helpers.formatarData(dados.dataFim,'MM');
            let anos = [];
            for(let i = anoInicial; i <= anoFinal; i++){
                let ano = {
                    ano: i,
                    meses: []
                };
                let mes = 1;
                if(i == anoInicial){
                    mes = mesInicial;
                }
                for(let j = mes; j <= (i == anoFinal ? mesFinal : 12); j++){
                    ano.meses.push(
                        {
                            mes : j,
                            nomeMes : helpers.retornarNomeMes(j),
                        }
                    );
                }
                anos.push(ano);
            }

            return anos;
        },
        montarAnos : function(){
            this.anos = [];            
            
            for(let i = this.filtro.anoInicio; i <= this.filtro.anoFinal; i++){
                let ano = {
                    ano: i,
                    meses: []
                };
                let mes = 1;
                if(i == this.filtro.anoInicio){
                    mes = this.filtro.mesInicio;
                }
                for(let j = mes; j <= (i == this.filtro.anoFinal ? this.filtro.mesFinal : 12); j++){
                    ano.meses.push(
                        {
                            mes : j,
                            nomeMes : helpers.retornarNomeMes(j),
                        }
                    );
                }
                this.anos.push(ano);
            }
        },
    },
    computed : {
        empresaSelecionada() {
            return this.$store.state.app.selectedCompanyObj.id;
        },
    },
    watch : {
        empresaSelecionada : {
            handler(){
                this.buscar({});
            },
            immediate : true
        }
    }
}
</script>
<style lang="scss">
    .avatar-accordion {
        position: absolute;
        top: -14px;
        border: 2px solid #FFF;
        width: 50px;
        height: 50px;
        left: 6px;
    }
    .accordion-com-avatar{
         .title{
            padding-left: 50px;
         }
    }
</style>